"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var i18n_1 = require("../i18n");
var geographicAddress = /** @class */ (function () {
    function geographicAddress(props) {
        var _this = this;
        this.geographicAddressId = props.geographicAddressId;
        this.streetAddress = props.streetAddress;
        this.addressComplement = props.addressComplement;
        this.inseeCode = props.inseeCode;
        this.zipCode = props.zipCode;
        this.commune = props.commune;
        this.city = props.city;
        this.country = props.country;
        this.countryCode = props.countryCode;
        this.building = props.building;
        this.stairs = props.stairs;
        this.floor = props.floor;
        this.door = props.door;
        this.lane = props.lane;
        this.number = props.number;
        this.toString = function (translations) {
            if (_this.addressComplement) {
                return "".concat(_this.streetAddress, " ").concat(_this.addressComplement, " ").concat(_this.buildAddressPrecision(translations)).concat(_this.city);
            }
            return "".concat(_this.streetAddress, " ").concat(_this.buildAddressPrecision(translations)).concat(_this.city);
        };
        this.buildAddressPrecision = function (translations) {
            if (_this.building || _this.stairs || _this.floor || _this.door) {
                return "".concat(_this.building !== null ? "".concat((0, i18n_1.getTransation)(function (t) { return t.geographicAddressModel.building; })(translations), " ").concat(_this.building, " ") : '')
                    + "".concat(_this.stairs !== null ? "".concat((0, i18n_1.getTransation)(function (t) { return t.geographicAddressModel.stairs; })(translations), " ").concat(_this.stairs, " ") : '')
                    + "".concat(_this.floor !== null ? "".concat((0, i18n_1.getTransation)(function (t) { return t.geographicAddressModel.floor; })(translations), " ").concat(_this.floor, " ") : '')
                    + "".concat(_this.door !== null ? "".concat((0, i18n_1.getTransation)(function (t) { return t.geographicAddressModel.door; })(translations), " ").concat(_this.door, " ") : '');
            }
            return '';
        };
    }
    return geographicAddress;
}());
exports.default = geographicAddress;
